import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { setLanguage } from '../../actions/language.js';
import { changePlayerCookie } from '../../actions/player.js';

const LANGUAGES = [
    { code: 'language_EN', flag: '/images/flag_uk.png', alt: 'UK Flag', label: 'English' },
    { code: 'language_DE', flag: '/images/flag_ger.png', alt: 'German Flag', label: 'Deutsch' },
    { code: 'language_FR', flag: '/images/flag_fr.png', alt: 'French Flag', label: 'Français' }
];

//compact flag + dropdown language switcher used in the TopBar once a room exists (Lobby onward)
const LanguageDropdown = () => {
    const dispatch = useDispatch();
    const playerData = useSelector((state) => state.Cookie);
    const selectedLanguage = useSelector((state) => state.Language);
    const [anchorEl, setAnchorEl] = useState(null);

    const current = LANGUAGES.find((lang) => lang.code === selectedLanguage) || LANGUAGES[0];

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleSelect = (newLanguage) => {
        const newPlayerData = {
            playerId: playerData.playerId,
            playerName: playerData.playerName,
            playerLanguage: newLanguage
        };
        dispatch(setLanguage(newLanguage));
        dispatch(changePlayerCookie(newPlayerData));
        handleClose();
    };

    return (
        <>
            <IconButton size="small" onClick={handleOpen} aria-label="Language">
                <img src={current.flag} alt={current.alt} style={{ width: '20px', display: 'block' }} />
                <ExpandMoreIcon sx={{ fontSize: '16px', ml: '2px' }} />
            </IconButton>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
                {LANGUAGES.map((lang) => (
                    <MenuItem key={lang.code} selected={lang.code === selectedLanguage} onClick={() => handleSelect(lang.code)}>
                        <ListItemIcon>
                            <img src={lang.flag} alt={lang.alt} style={{ width: '20px' }} />
                        </ListItemIcon>
                        <ListItemText>{lang.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageDropdown;
